import Home from '@/pages/home/index';

function getRouterList(successCallback) {
  // 登录之后获取动态路由
  let userRouter = ''
  let role_router = ''
  role_router = localStorage.getItem('dynamicRoutes')
  if (role_router) {
    userRouter = JSON.parse(role_router)
  }
  let defaultRoutes = [
    {
    path: '/login',
    component: () => import('@/pages/login.vue'),
    name: '',
    hidden: true,
  }, {
      path: '/reset_password',
      component: () => import('@/pages/setting/resetPassword.vue'),
      name: 'reset_password',
      hidden: true,
      meta: {  no_login: true, }
  }, {
    path: '/',
    name: 'home',
    component: () => import('@/pages/home/index'),
    meta: { title: 'home', icon: 'peoples' }
    // hidden: true
  }, {
    path: '/403',
    name: '403',
    component: () => import('@/pages/home/403'),
    meta: { title: '403', icon: 'peoples' },
    hidden: true,
  },
  ]

  let dynamicRoutes = [
    {
      path: '/supplement',
      name: 'supplement',
      component: () => import('@/pages/supplement/index'),
      meta: { title: 'supplementManagement', icon: 'el-icon-s-order' },
      children: [
        {
          path: '/supplement_m',
          name: 'supplementManagement',
          component: () => import('@/pages/supplement/supplement'),
          meta: { title: 'supplementManagement', icon: 'peoples' }
        }, {
          path: '/barCode',
          name: 'barCode',
          component: () => import('@/pages/supplement/barCode'),
          meta: { title: 'barCode', icon: 'peoples' }
        }, {
          path: '/supplementDetail/:id?',
          name: 'supplementDetail',
          component: () => import('@/pages/supplement/supplementDetail'),
          meta: { title: 'supplementDetail', icon: 'peoples' },
          hidden: true,
        }, {
          path: '/outbound',
          name: 'outbound',
          component: () => import('@/pages/supplement/outbound'),
          meta: { title: 'outbound', icon: 'peoples' }
        }, {
          path: '/user_supplement/:user_id?',
          name: 'userSupplement',
          component: () => import('@/pages/customerManagement/userSupplement'),
          meta: { title: 'customerManagement', icon: 'peoples' },
          hidden: true,
        }
      ]
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('@/pages/product/index'),
      meta: { title: 'productManagement', icon: 'el-icon-s-shop' },
      children: [
        {
          path: '/classification',
          name: 'classification',
          component: () => import('@/pages/product/classification'),
          meta: { title: 'classification', icon: 'peoples' }
        }, {
          path: '/colors',
          name: 'colors',
          component: () => import('@/pages/product/colors'),
          meta: { title: 'colors', icon: 'peoples' }
        },
        {
          path: '/product_management',
          name: 'productManagement',
          component: () => import('@/pages/product/productManagement'),
          meta: { title: 'productManagement', icon: 'peoples' }
        }, {
          path: '/parts',
          name: 'parts',
          component: () => import('@/pages/product/parts'),
          meta: { title: 'accessoriesManagement', icon: 'peoples' }
        }, {
          path: '/product_edit/:id?',
          name: 'productEdit',
          component: () => import('@/pages/product/addOrEditProduct'),
          meta: { title: 'productEdit', icon: 'peoples' },
          hidden: true
        }, {
          path: '/manufacturer',
          name: 'manufacturer',
          component: () => import('@/pages/product/manufacturer'),
          meta: { title: 'manufacturer', icon: 'peoples' },
        }
      ]
    }, {
      path: '/instructions',
      name: 'instructions',
      component: () => import('@/pages/product/instructions'),
      meta: { title: 'instructions', icon: 'el-icon-tickets' }
    }, {
      path: '/customer_management',
      name: 'customerManagement',
      component: () => import('@/pages/customerManagement/userManagement'),
      meta: { title: 'customerManagement', icon: 'el-icon-user-solid' },
      // children: [
      //   {
      //     path: '/user_management',
      //     name: 'userManagement',
      //     component: () => import('@/pages/customerManagement/userManagement'),
      //     meta: { title: 'customerManagement', icon: 'peoples' }
      //   },
      //   {
      //     path: '/user_supplement/:user_id?',
      //     name: 'userSupplement',
      //     component: () => import('@/pages/customerManagement/userSupplement'),
      //     meta: { title: 'customerManagement', icon: 'peoples' },
      //     hidden: true,
      //   }
      // ]
    }, {
      path: '/security_code',
      name: 'security_code',
      required: [ 'enabled_security_code' ],
      component: () => import('@/pages/securityCode/index'),
      meta: {title: 'antiCounterfeitCode', icon: 'el-icon-tickets'},
      children: [
        {
          path: '/anti_code',
          name: 'anti_counterfeit_code',
          component: () => import('@/pages/securityCode/antiCounterfeitCode'),
          meta: { title: 'securityList', icon: 'peoples' }
        }, {
          path: '/code_batches',
          name: 'code_batches',
          component: () => import('@/pages/securityCode/batches'),
          meta: { title: 'codeBatches', icon: 'peoples' }
        }, {
          path: '/company_customer',
          name: 'company_customer',
          component: () => import('@/pages/securityCode/customer'),
          meta: { title: 'companyCustomer', icon: 'peoples' },
        }
      ]
    }, {
      path: '/business_management',
      name: 'businessManagement',
      component: () => import('@/pages/businessManagement/index'),
      meta: { title: 'businessManagement', icon: 'el-icon-s-tools' },
      children: [{
        path: '/officer',
        name: 'officer',
        component: () => import('@/pages/businessManagement/officer'),
        meta: { title: 'employeeManagement', icon: 'peoples' }
      }, {
        path: '/roles',
        name: 'roles',
        component: () => import('@/pages/businessManagement/roles'),
        meta: { title: 'rolesManager', icon: 'peoples' },
        hidden: true
      }, {
        path: '/sales_platform',
        name: 'sales_platform',
        component: () => import('@/pages/businessManagement/salesPlatform'),
        meta: { title: 'salesPlatformManagement', icon: 'peoples' },
      },{
        path: '/supplement_reason',
        name: 'supplement_reason',
        component: () => import('@/pages/businessManagement/supplementReason'),
        meta: { title: 'supplementReason', icon: 'peoples' },
      }, {
        path: '/send_time_cycle',
        name: 'send_time_cycle',
        required: [ 'enabled_send_time_cycle' ],
        component: () => import('@/pages/businessManagement/sendTimeCycle'),
        meta: { title: 'sendTimeCycleManagement', icon: 'peoples' },
      }, {
        path: '/express_company',
        name: 'express_company',
        component: () => import('@/pages/businessManagement/expressCompany'),
        meta: { title: 'expressCompany', icon: 'peoples' },
      }, {
        path: '/advertisement',
        name: 'advertisement',
        component: () => import('@/pages/businessManagement/advertisement'),
        meta: { title: 'advertisingManagement', icon: 'peoples' },
      }, {
        path: '/activities',
        name: 'activities',
        component: () => import('@/pages/businessManagement/activities'),
        meta: { title: 'activitiesManagement', icon: 'peoples' },
      },
      // ,{
      //   path:'/user_identity',
      //   name:'user_identity',
      //   component: () => import('@/pages/businessManagement/userIdentity'),
      //   meta: { title: 'userIdentityManagement', icon: 'peoples' },
      // },
      {
        path:'/payment_management',
        name:'payment_management',
        component: () => import('@/pages/businessManagement/paymentManagement'),
        meta: { title: 'paymentManagement', icon: 'peoples' },
      },{
        path:'/auto_verify_management',
        name:'auto_verify_management',
        component: () => import('@/pages/businessManagement/autoVerifyManagement'),
        meta: { title: 'autoVerifyManagement', icon: 'peoples' },
      }]
    }, {
      path: '/setting',
      name: 'setting',
      component: () => import('@/pages/setting/index'),
      meta: { title: 'setting', icon: 'el-icon-setting'},
      children: [
        {
          path: '/enterprise_information',
          name: 'enterpriseInformation',
          component: () => import('@/pages/businessManagement/enterpriseInformation'),
          meta: { title: 'enterpriseInformation', icon: 'peoples' }
        }, {
          path: '/change_password',
          name: 'changePassword',
          component: () => import('@/pages/businessManagement/changePassword'),
          meta: { title: 'changePassword', icon: 'peoples' }
        }, {
          path: '/verification_method',
          name: 'verification_method',
          component: () => import ('@/pages/businessManagement/verificationMethod'),
          meta: { title: 'verificationMethod', icon: 'peoples' },
        }, {
          path:'/user_service_agreement',
          name:'user_service_agreement',
          component: () => import('@/pages/businessManagement/serviceAgreement'),
          meta: { title: 'serviceAgreement', icon: 'peoples' },
        },
      ]
    }

  ]

  // 合并路由
  let list = [...defaultRoutes, ...dynamicRoutes]
  successCallback(list)
  console.log(list)
}
export default {
  getRouterList
}



// WEBPACK FOOTER //
// ./src/router/dynamicRouter.js